import React, { useState } from "react";
import CFSelect from "../shared/forms/CFSelect";
import Tooltip from "../shared/Tooltip";

const GOAL_OPTIONS = [
  { value: "checkouts", label: "Checkouts" },
  { value: "bookings", label: "Bookings" },
  { value: "custom", label: "Custom goal" },
];

const DEFAULT_GOALS = ["checkouts", "bookings"];
const SAMPLE_SCRIPT = "convertflow.trackCustomGoal();";

const optionsFor = (values) => {
  const selected = GOAL_OPTIONS.filter((option) =>
    values.includes(option.value)
  );
  return selected.length > 0 ? selected : [GOAL_OPTIONS[0]];
};

const ReportingGoalsSettings = (props) => {
  const [selected, setSelected] = useState(
    optionsFor(
      Array.isArray(props.selectedGoals) ? props.selectedGoals : DEFAULT_GOALS
    )
  );
  const [customName, setCustomName] = useState(props.customGoalName || "");
  const [copied, setCopied] = useState(false);
  const customSelected = selected.some((option) => option.value === "custom");

  const copySample = async () => {
    try {
      await navigator.clipboard.writeText(SAMPLE_SCRIPT);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <div className="row hard-center">
      <div
        className="col-xs-12 form-inputs mt-7"
        style={{ paddingRight: "5px" }}
      >
        <span className="field-title">
          Reporting goals{" "}
          <Tooltip
            inline={true}
            tooltip="Choose which conversion goals appear in reports and AI insights for this website. At least one goal is required."
          />
        </span>
        <input
          type="hidden"
          name="website[data][reporting-goals]"
          value={JSON.stringify(selected.map((option) => option.value))}
        />
        <CFSelect
          aria-label="Reporting goals"
          isMulti={true}
          isClearable={false}
          options={GOAL_OPTIONS}
          value={selected}
          placeholder="Select reporting goals"
          onChange={(value) =>
            setSelected(optionsFor((value || []).map((option) => option.value)))
          }
        />
      </div>

      {customSelected && (
        <React.Fragment>
          <div
            className="col-xs-12 form-inputs mt-7"
            style={{ paddingRight: "5px" }}
          >
            <span className="field-title">Custom goal name</span>
            <input
              aria-label="Custom goal name"
              type="text"
              className="text-field"
              name="website[data][reporting-custom-goal-name]"
              value={customName}
              placeholder="e.g. Demo requested"
              onChange={(event) => setCustomName(event.target.value)}
            />
          </div>

          <div
            className="col-xs-12 form-inputs mt-7"
            style={{ paddingRight: "5px" }}
          >
            <span className="field-title">Custom goal tracking script</span>
            <p
              className="text-xl text-slate-500"
              style={{ marginBottom: "8px" }}
            >
              Fire this after convertflow.js has loaded to count a{" "}
              {customName.trim() || "custom goal"} in reports.
            </p>
            <textarea
              aria-label="Custom goal tracking script"
              readOnly
              className="text-field"
              rows="3"
              value={SAMPLE_SCRIPT}
              style={{ fontFamily: "monospace" }}
            />
            <button
              type="button"
              className="btn toolbar-btn field-title !border-slate-200 bg-white !text-black !h-[34px] !inline-flex !items-center !py-0 !px-3 mt-3"
              onClick={copySample}
            >
              {copied ? "Copied" : "Copy script"}
            </button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ReportingGoalsSettings;
